import { WSElement, WSTableCell } from "@wingspanhq/fe-component-library";
import { useBulkCollaboratorBatchSummary } from "../../query/bulkCollaborator/queries";

export function TotalCollaboratorsCount({ batchId }: { batchId: string }) {
  const qBulkCollaboratorBatchItems = useBulkCollaboratorBatchSummary(batchId);

  if (qBulkCollaboratorBatchItems.isLoading) {
    return <WSElement shimmer={true}>loading</WSElement>;
  }

  return (
    <WSTableCell
      text={
        qBulkCollaboratorBatchItems.data?.collaboratorsCount === undefined
          ? undefined
          : String(qBulkCollaboratorBatchItems.data?.collaboratorsCount)
      }
    />
  );
}
